import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";

import UpdatePasswordForm from "../components/UpdatePasswordForm";

export default function CreatePasswordScreen() {
    const { t } = useTranslation("auth");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (!token) {
        return <ErrorScreen error={new Error("Missing token")} />;
    }

    return (
        <GaiaPageLayoutColumn maxWidth="sm">
            <GaiaPageComponent title={t("createPasswordScreen.title")}>
                <Typography variant="body1" mb={3}>
                    {t("createPasswordScreen.description")}
                </Typography>
                {token && (
                    <UpdatePasswordForm token={token} submitButtonText={t("createPasswordScreen.btnCreatePassword")} />
                )}
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
